import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@solana/wallet-adapter-react-ui/styles.css';
import './css/index.css'
import './css/mk-brand.css';
import React, {FC, ReactNode, useMemo} from 'react';
import {WalletAdapterNetwork} from '@solana/wallet-adapter-base';
import {ConnectionProvider, WalletProvider} from '@solana/wallet-adapter-react';
import {WalletModalProvider} from '@solana/wallet-adapter-react-ui';
import {
    LedgerWalletAdapter,
    PhantomWalletAdapter,
    SlopeWalletAdapter,
    SolflareWalletAdapter,
    SolletExtensionWalletAdapter,
    SolletWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import {clusterApiUrl} from '@solana/web3.js';
import {Routes, Route, HashRouter} from 'react-router-dom';
import Layout from './components/layout';
import Home from './pages/home';
import Game from './pages/game';
import Collections from './pages/collections';
import Team from './pages/team';
import Papers from './pages/papers';
import Mint from './pages/mint';
import MyKitchen from './pages/my-kitchen'
import Staking from "./pages/staking";
import SuperOG from "./pages/super-og";
import config from './config'

let network = config.SOLANA_NETWORK || WalletAdapterNetwork.Devnet;


const App: FC = () => {
    return (
        <Context>
            <Content/>
        </Context>
    );
};
export default App;

const Context: FC<{ children: ReactNode }> = ({children}) => {

    // You can also provide a custom RPC endpoint.
    const endpoint = useMemo(() => clusterApiUrl(network), [network]);

    // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking and lazy loading --
    // Only the wallets you configure here will be compiled into your application, and only the dependencies
    // of wallets that your users connect to will be loaded.
    const wallets = useMemo(
        () => [
            new PhantomWalletAdapter(),
            new SlopeWalletAdapter(),
            new SolflareWalletAdapter({network}),
            //new TorusWalletAdapter(),
            new LedgerWalletAdapter(),
            new SolletWalletAdapter({network}),
            new SolletExtensionWalletAdapter({network}),
        ],
        [network]
    );

    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect>
                <WalletModalProvider>{children}</WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};


const Content: FC = () => {
    return (
        <>
            <HashRouter>
                <Routes>
                    <Route path="/" element={<Layout/>}>
                        <Route index element={<Home/>}/>
                        <Route path="/home" element={<Home/>}/>
                        <Route path="/game" element={<Game/>}/>
                        <Route path="/collections" element={<Collections/>}/>
                        <Route path="/team" element={<Team/>}/>
                        <Route path="/papers" element={<Papers/>}/>
                        <Route path="/mint" element={<Mint/>}/>
                        <Route path="/my-kitchen" element={<MyKitchen/>}/>
                        <Route path="/staking" element={<Staking/>}/>
                        <Route path="/super-og/:panel/:frame/:id/" element={<SuperOG />} />
                    </Route>
                </Routes>
            </HashRouter>
        </>
    )
};
